import React from "react";

/** Shared inline-style constants for Risk Assessment views */
export const S = {
	body: { padding: "24px 28px" } as React.CSSProperties,
	lbl: {
		display: "block",
		color: "#64748B",
		fontSize: 11,
		fontWeight: 700,
		letterSpacing: "0.1em",
		textTransform: "uppercase" as const,
		marginBottom: 8,
	} as React.CSSProperties,
	inp: {
		width: "100%",
		background: "#fff",
		border: "1px solid #CBD5E1",
		borderRadius: 10,
		padding: "11px 14px",
		color: "#1E293B",
		fontSize: 14,
		outline: "none",
		boxSizing: "border-box" as const,
	} as React.CSSProperties,
	ghost: {
		background: "transparent",
		border: "1px solid #CBD5E1",
		borderRadius: 10,
		padding: "11px 18px",
		color: "#64748B",
		fontSize: 13,
		fontWeight: 600,
		cursor: "pointer",
	} as React.CSSProperties,
};

export const sel = (on: boolean): React.CSSProperties => ({
	background: on ? "#EFF6FF" : "#fff",
	border: on ? "1.5px solid #1B3A6B" : "1px solid #E2E8F0",
	borderRadius: 10,
	cursor: "pointer",
	transition: "all 0.15s",
});

export const primary = (on: boolean): React.CSSProperties => ({
	width: "100%",
	background: on ? "linear-gradient(135deg,#1B3A6B,#2E5FA3)" : "#E2E8F0",
	color: on ? "#fff" : "#94A3B8",
	border: "none",
	borderRadius: 10,
	padding: "13px",
	fontSize: 14,
	fontWeight: 700,
	cursor: on ? "pointer" : "not-allowed",
	marginTop: 20,
	letterSpacing: "0.02em",
	transition: "all 0.2s",
});
